import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateGuideByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  _set?: Types.InputMaybe<Types.Guides_Set_Input>;
}>;


export type UpdateGuideByIdMutation = { __typename?: 'mutation_root', update_guides_by_pk?: { __typename?: 'guides', id: any } | null };


export const UpdateGuideByIdDocument = gql`
    mutation updateGuideById($id: uuid!, $_set: guides_set_input = {}) {
  update_guides_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;
export type UpdateGuideByIdMutationFn = Apollo.MutationFunction<UpdateGuideByIdMutation, UpdateGuideByIdMutationVariables>;

/**
 * __useUpdateGuideByIdMutation__
 *
 * To run a mutation, you first call `useUpdateGuideByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuideByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuideByIdMutation, { data, loading, error }] = useUpdateGuideByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateGuideByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGuideByIdMutation, UpdateGuideByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGuideByIdMutation, UpdateGuideByIdMutationVariables>(UpdateGuideByIdDocument, options);
      }
export type UpdateGuideByIdMutationHookResult = ReturnType<typeof useUpdateGuideByIdMutation>;
export type UpdateGuideByIdMutationResult = Apollo.MutationResult<UpdateGuideByIdMutation>;
export type UpdateGuideByIdMutationOptions = Apollo.BaseMutationOptions<UpdateGuideByIdMutation, UpdateGuideByIdMutationVariables>;